import { render } from "./CaseClinicalInformation.vue?vue&type=template&id=e28f2182&scoped=true&ts=true"
import script from "./CaseClinicalInformation.vue?vue&type=script&lang=ts"
export * from "./CaseClinicalInformation.vue?vue&type=script&lang=ts"

import "./CaseClinicalInformation.vue?vue&type=style&index=0&id=e28f2182&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e28f2182"]])

export default __exports__